


















import { Component, Vue, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Company } from '../store/company'
import MachineForm from './MachineForm.vue'
import { MachineDetail, EditMachine, MachineOverview } from '../store/machine'
import { Sensor } from '../store/sensor'
import { Alarm } from '../store/alarm'
import { Warning } from '../store/warning'
const company = namespace('company')
const sensor = namespace('sensor')
const alarm = namespace('alarm')
const warning = namespace('warning')

const machine = namespace('machine')

@Component({ components: { MachineForm } })
export default class EditMachineModal extends Vue {
  @machine.Action edit!: (machine: EditMachine) => Promise<MachineOverview>
  @sensor.Getter sensors!: Sensor[]
  @alarm.Getter alarms!: Alarm[]
  @warning.Getter warnings!: Warning[]
  @company.Getter companies!: Company[]
  @Prop() machine!: MachineDetail
  dialog = false

  async editMachine(input: EditMachine) {
    await this.edit(input)
    this.dialog = false
    this.$emit('done')
  }
}
